module.exports = __webpack_public_path__ + "img/624.7a5ae12e.jpg";